export const formatTextWithBreaks = (content: string) => {
  const hasLineBreaks = content.includes("\n")

  if (hasLineBreaks) {
    const paragraphs = content
      .split("\n")
      .filter((p: string) => p.trim() !== "")

    return (
      <>
        {paragraphs.map((paragraph: string, index: number) => (
          <p key={index}>{paragraph}</p>
        ))}
      </>
    )
  } else {
    return <p>{content}</p>
  }
}
